
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TranslationItemModel from "@models/translationItemModel";

@Component
export default class TranslateListComponent extends Vue {
  @Prop() translations: Array<TranslationItemModel>;
  @Prop({ default: false }) horizontal: boolean;

  imageLanguageCodes: string[] = ["ru", "en", "ro"];
  languageCountryCodes: Record<string, string> = {
    ar: "SA",
    bg: "BG",
    cs: "CZ",
    da: "DK",
    de: "DE",
    el: "GR",
    es: "ES",
    et: "EE",
    fi: "FI",
    fr: "FR",
    he: "IL",
    hi: "IN",
    hr: "HR",
    hu: "HU",
    id: "ID",
    it: "IT",
    ja: "JP",
    ko: "KR",
    lt: "LT",
    lv: "LV",
    nl: "NL",
    no: "NO",
    pl: "PL",
    pt: "PT",
    sk: "SK",
    sl: "SI",
    sr: "RS",
    sv: "SE",
    tr: "TR",
    uk: "UA",
    vi: "VN",
    zh: "CN",
  };

  created() {}

  normalizeLangCode(langCode: string): string {
    return (langCode || "").trim().toLocaleLowerCase().split("-")[0];
  }

  hasImage(langCode: string): boolean {
    return this.imageLanguageCodes.includes(this.normalizeLangCode(langCode));
  }

  getImage(langCode: string): string {
    return `/assets/img/flags/${this.normalizeLangCode(langCode)}.png`;
  }

  getFlagEmoji(langCode: string): string {
    const normalizedLangCode = this.normalizeLangCode(langCode);
    const countryCode =
      this.languageCountryCodes[normalizedLangCode] ||
      (normalizedLangCode.length === 2
        ? normalizedLangCode.toLocaleUpperCase()
        : "");

    if (!countryCode) return "🌐";

    return countryCode
      .split("")
      .map((letter) =>
        String.fromCodePoint(127397 + letter.charCodeAt(0))
      )
      .join("");
  }

  mounted() {}
}
